module.exports = __webpack_public_path__ + "img/preset2.2903b70f.png";